import { Inject, Injectable, Optional } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { LocalStorage } from "@dffedb/util";
import { APP_SHELL_LAYOUT_OPTIONS, AppShellLayoutOptions } from "../app-shell/app-shell-layout.token";
import { getLoginRouteByPreference, isTeknikerContext } from "../util";

import { LoginService } from "./login.service";

@Injectable({ providedIn: "root" })
export class LogoutRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private localStorage: LocalStorage,
        private loginService: LoginService,
        @Optional() @Inject(APP_SHELL_LAYOUT_OPTIONS) private readonly appShellLayout: AppShellLayoutOptions | null
    ) {}

    canActivate(): boolean | UrlTree {
        this.loginService.logout();
        const page = this.localStorage.getItem("sidste-login-side");
        const fallback = getLoginRouteByPreference(page, isTeknikerContext());
        const configured = this.appShellLayout?.teknikerLoginRoute?.trim();
        const target = configured ? (configured.startsWith("/") ? configured : `/${configured}`) : fallback;
        return this.router.parseUrl(target);
    }
}
